module.exports = __webpack_public_path__ + "img/logo.27a21672.png";